import { FC, useState, ReactNode } from 'react';
// mui components
import { Grid } from '@mui/material';
// components
import FileViewerModal, {
  IProps as FileViewerProps,
} from 'components/modal/file-viewer-modal/index';
// custom hooks
import { useModalState } from 'hooks/useModalState';
// styles
import { uploadedFilesStyles as styles } from '../../uploaded-files/styles/styles';

export const FileWrapper: FC<Pick<FileViewerProps, 'url' | 'mimeType'> & { children?: ReactNode }> = ({
  children,
  ...fileViewerProps
}) => {
  const [isOpen, openModal, closeModal] = useModalState();

  return (
    <>
      <Grid onClick={openModal} sx={styles.wrapperContainer}>
        {children}

      </Grid>
      <FileViewerModal open={isOpen} handleClose={closeModal} {...fileViewerProps} />
    </>
  );
};
